import Immutable from 'immutable';

import { createModuleState } from 'ps-gui';

const EMPTY_MAP = Immutable.Map({});
const EMPTY_STATE = createModuleState('Notifications');

export default class NotificationModel {
	#data;

	constructor(data) {
		this.#data = data || EMPTY_MAP;
	}

	getData() {
		return this.#data;
	}

	getState() {
		return EMPTY_STATE.set('data', this.#data);
	}
}

